<template>
  <div>
    <!-- MODO “TELA NORMAL”: formulário + botão -->
    <div v-if="!printMode">
      <h6>Receitas por Período</h6><p></p>
      <div class="row mb-3">
        <div class="col-auto">
          <label>Data Início:</label>
          <input type="date" v-model="dataInicioLocal" class="form-control" />
        </div>
        <div class="col-auto">
          <label>Data Fim:</label>
          <input type="date" v-model="dataFimLocal" class="form-control" />
        </div>
        <div class="col-auto align-self-end">
          <button @click="abrirPrint" class="btn btn-primary">Executar</button>
        </div>
      </div>
    </div>

    <!-- MODO “IMPRESSÃO/PRINT”: só exibe tabela com total -->
    <div v-else>
      <p class="text-center" style="font-size: 14px;">
        ( {{ globalUtils.formatarData(dataInicio) }} a {{ globalUtils.formatarData(dataFim) }} )
      </p>

      <div v-if="loading">Carregando…</div>
      <div v-else-if="resultados.length">
        <table class="table table-striped">
          <thead>
            <tr>
              <th>REFIL</th>
              <th>DESCRIÇÃO</th>
              <th class="valor-cell">VALOR</th>
              <th class="text-center">FORMA DE PAGAMENTO</th>
              <th class="text-center">DATA VENCIMENTO</th>
              <th class="text-center">DATA PAGAMENTO</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(item, idx) in resultados"
              :key="item.data_vencimento + '-' + item.descricao + '-' + idx"
            >
              <td>{{ item.refil }}</td>
              <td>{{ item.descricao }}</td>
              <td class="valor-cell">{{ formatarMoeda(item.valor) }}</td>
              <td class="text-center">{{ item.forma_pagamento }}</td>
              <td class="text-center">{{ globalUtils.formatarData(item.data_vencimento) }}</td>
              <td class="text-center">{{ globalUtils.formatarData(item.data_pagamento) }}</td>
            </tr>
          </tbody>
          <!-- ADICIONA O RODAPÉ COM TOTAL -->
          <tfoot>
            <tr>
              <td colspan="2"><strong>Total</strong></td>
              <td class="valor-cell text-right">
                <strong>{{ formatarMoeda(total) }}</strong>
              </td>
              <td colspan="3"></td>
            </tr>
          </tfoot>
        </table>
      </div>
      <div v-else>
        <p>Nenhum registro encontrado para este período.</p>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import axios from '@/services/axios'
import globalUtils from '@/utils/globalUtils.js'

const props = defineProps({
  printMode: { type: Boolean, default: false },
  dataInicio: String,
  dataFim:    String,
  printTitle: { type: String, default: 'Receitas por Período' },
  subtitle:   { type: String, default: '' }
})

const router = useRouter()

// Estados locais (modo “tela normal”)
const dataInicioLocal = ref('')
const dataFimLocal    = ref('')

// Estados de resultado (modo “print”)
const loading     = ref(false)
const resultados  = ref([])
const total       = ref(0)

onMounted(async () => {
  if (!props.printMode) return
  if (!props.dataInicio || !props.dataFim) return

  loading.value = true
  try {
    const res = await axios.get(
      '/gestao/relatorios/receitas/receitas-por-periodo',
      {
        params: {
          dataInicio: props.dataInicio,
          dataFim:    props.dataFim
        }
      }
    )
    resultados.value = Array.isArray(res.data.items) ? res.data.items : []
    total.value      = parseFloat(res.data.total) || 0
  } catch (e) {
    console.error('Erro ao buscar receitas por período (print):', e)
    resultados.value = []
    total.value      = 0
  } finally {
    loading.value = false
  }
})

function abrirPrint() {
  if (!dataInicioLocal.value || !dataFimLocal.value) return

  const inicioFormatado = globalUtils.formatarData(dataInicioLocal.value)
  const fimFormatado    = globalUtils.formatarData(dataFimLocal.value)
  const subtitleLocal   = `( ${inicioFormatado} a ${fimFormatado} )`

  router.push({
    path: '/gestao/relatorios/print/receitas-por-periodo',
    query: {
      title:      props.printTitle,
      dataInicio: dataInicioLocal.value,
      dataFim:    dataFimLocal.value,
      subtitle:   subtitleLocal
    }
  })
}

function formatarMoeda(num) {
  if (num == null) return ''
  return Number(num).toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  })
}
</script>

<style scoped>
.mb-3 {
  margin-bottom: 1rem;
}
.valor-cell {
  text-align: right !important;
}
.text-right {
  text-align: right !important;
}
</style>
